define([
    "../hereMapsModule",
    "text!./undoButton.html",
    "text!./polygonNameModal.html",
], function (hereMapsModule, undoButtonTemplate, polygonNameModalTemplate) {
    "use strict";

    return hereMapsModule.directive("hereMapsPolygonDrawingManager", [
        "hereMapsService",
        function (hereMapsService) {
            return {
                restrict: "E",
                scope: {
                    polygons: "=",
                    onRegisterApi: "=",
                },
                controller: ["$scope",
                    "$compile",
                    "messagesModal",
                    "hereMapsPolygonDrawingManagerFactory",
                    function ($scope,
                              $compile,
                              messagesModal,
                              hereMapsPolygonDrawingManagerFactory) {
                        $scope.Here = null;
                        $scope.map = null;
                        $scope.behavior = null;
                        $scope.specifyBundleConfirm = null;
                        $scope.isProcessingDeleteTap = false;
                        var polygonDeleteTapEvent = null;
                        var polygonDeleteGroupsTapEvent = null;
                        var vertexPolygonPointerenterEvent = null;
                        var vertexPolygonPointerleaveEvent = null;
                        var vertexPolygonDragstartEvent = null;
                        var vertexPolygonDragEvent = null;
                        var returnMarkerTapEvent = null;

                        init();

                        function init() {
                            $scope.Here = hereMapsService.getHere();
                            $scope.map = hereMapsService.getMap();
                            $scope.behavior = hereMapsService.getBehavior();
                            $scope.ui = hereMapsService.getUi();
                            $scope.openBubblesByPolygon = {};

                            if (!$scope.Here || !$scope.map || !$scope.onRegisterApi) {
                                return;
                            }

                            $scope.icon = new $scope.Here.map.Icon("images/circle-solid-white.svg", {
                                anchor: {x: 5, y: 3}
                            });
                            $scope.hoverIcon = new $scope.Here.map.Icon("images/circle-solid-gray.svg", {
                                anchor: {x: 5, y: 3}
                            });

                            $scope.returnMarker = null;
                            $scope.polygonGroup = new $scope.Here.map.Group();
                            $scope.vertexGroup = new $scope.Here.map.Group();
                            // grupo de grupo de poligono
                            $scope.othersPolygonGroups = new $scope.Here.map.Group();
                            $scope.mainGroup = new $scope.Here.map.Group({
                                volatility: true,
                                objects: [$scope.polygonGroup, $scope.vertexGroup, $scope.othersPolygonGroups],
                            });
                            drawPolygons($scope.polygons);
                            centerMapOnPolygon();
                            $scope.map.addObject($scope.mainGroup);
                        }

                        var polygonDrawerApi = {};

                        polygonDrawerApi.addPolygons = function (polygons) {
                            var herePolygons = hereMapsPolygonDrawingManagerFactory
                                .createPolygons(polygons);
                            drawPolygons(herePolygons);
                        };

                        polygonDrawerApi.getPolygons = function () {
                            return $scope.polygonGroup.getObjects().map(function (eachPolygon) {
                                return convertPolygonToModel(eachPolygon);
                            });
                        };

                        polygonDrawerApi.centerMapOnPolygon = function () {
                            centerMapOnPolygon();
                        };

                        polygonDrawerApi.clearPolygons = function () {
                            if ($scope.polygonGroup) {
                                $scope.polygonGroup.removeAll();
                            }
                        };

                        polygonDrawerApi.setSpecifyBundleConfirm = function (bundleConfirm) {
                            $scope.specifyBundleConfirm = bundleConfirm;
                        };

                        polygonDrawerApi.drawOthersPolygonGroups = function (othersPolygonGroups) {
                            drawOthersPolygonGroups(othersPolygonGroups);
                        };

                        polygonDrawerApi.clearOthersPolygonGroups = function (othersPolygonGroups) {
                            clearOthersPolygonGroups(othersPolygonGroups);
                        };

                        $scope.onRegisterApi(polygonDrawerApi);

                        function convertPolygonToModel(eachPolygon) {
                            var geometry = eachPolygon.getGeometry();
                            var coordsDoPolygon = [];
                            geometry.getExterior()
                                .eachLatLngAlt(function (lat, lng) {
                                    coordsDoPolygon.push(
                                        {
                                            lat: lat,
                                            lng: lng
                                        }
                                    );
                                });
                            return {
                                editable: eachPolygon.getData().editable,
                                points: coordsDoPolygon
                            };
                        }

                        function drawPolygons(polygons) {
                            if (polygons.length === 0) {
                                return;
                            }
                            for (var i = 0; i < polygons.length; i++) {
                                var polygon = polygons[i];
                                $scope.polygonGroup.addObject(polygon);
                                addEditableListener(polygon);
                            }
                            addDeleteListener();
                        }

                        function centerMapOnPolygon() {
                            if ($scope.polygonGroup.getObjects().length === 0) {
                                return;
                            }
                            $scope.map.getViewModel().setLookAtData({
                                bounds: $scope.mainGroup.getBoundingBox(),
                            });
                        }

                        function addDeleteListener() {
                            polygonDeleteTapEvent = function (event) {
                                if (isRightButton(event)) {
                                    return;
                                }
                                if ($scope.isProcessingDeleteTap) {
                                    return;
                                }
                                event.stopPropagation();
                                $scope.isProcessingDeleteTap = true;

                                messagesModal.cancellable("dialog.warning", [getConfirmBundle()])
                                    .then(function () {
                                        var currentPolygon = event.target;
                                        var data = currentPolygon.getData();
                                        if (data.vertexsMarkers && data.vertexsMarkers.length > 0) {
                                            $scope.vertexGroup.removeObjects(data.vertexsMarkers);
                                        }
                                        removeReturnMarker(currentPolygon);
                                        $scope.polygonGroup.removeObject(currentPolygon);
                                    })
                                    .finally(function () {
                                        $scope.isProcessingDeleteTap = false;
                                    });
                            };
                            $scope.polygonGroup.addEventListener("tap", polygonDeleteTapEvent);
                        }

                        function isLeftButton(event) {
                            return event.originalEvent.button === 0;
                        }

                        function isRightButton(event) {
                            return event.originalEvent.button !== 2;
                        }

                        function removeReturnMarker(polygon) {
                            if (!$scope.returnMarker) {
                                return;
                            }
                            var returnMarkerData = $scope.returnMarker.getData();
                            var vertexData = returnMarkerData.vertex.getData();
                            // apaga o returnMarker, se ele for do poligono apagado
                            if (polygon === vertexData.polygon) {
                                $scope.map.removeObject($scope.returnMarker);
                                $scope.returnMarker = null;
                            }
                        }

                        function addEditableListener(polygon) {
                            if (!polygon.getData().editable) {
                                return;
                            }

                            polygon.getData().vertexsMarkers = [];

                            // criar o markerVertex daquele poligono
                            polygon.getGeometry()
                                .getExterior()
                                .eachLatLngAlt(function (lat, lng, alt, index) {
                                    var vertexMarker = new $scope.Here.map.Marker(
                                        {
                                            lat: lat,
                                            lng: lng
                                        }, {
                                            icon: $scope.icon
                                        }
                                    );
                                    vertexMarker.draggable = true;
                                    vertexMarker.setData(
                                        {
                                            vertexIndex: index,
                                            polygon: polygon,
                                            lastMove: {
                                                lat: lat,
                                                lng: lng,
                                                alt: alt
                                            }
                                        }
                                    );
                                    polygon.getData().vertexsMarkers.push(vertexMarker);
                                    $scope.vertexGroup.addObject(vertexMarker);
                                });
                            vertexMarkersEvents();
                        }

                        function vertexMarkersEvents() {
                            vertexPolygonPointerenterEvent = function (event) {
                                event.target.setIcon($scope.hoverIcon);
                                event.stopPropagation();
                            };

                            vertexPolygonPointerleaveEvent = function (event) {
                                event.target.setIcon($scope.icon);
                                event.stopPropagation();
                            };

                            vertexPolygonDragstartEvent = function (event) {
                                // salva posição para o fluxo de desfazer a ação
                                var geometry = event.target.getGeometry();
                                event.target.getData().lastMove =
                                    {
                                        lat: geometry.lat,
                                        lng: geometry.lng,
                                        alt: geometry.alt || 0
                                    };
                            };

                            vertexPolygonDragEvent = function (event) {
                                var pointer = event.currentPointer;
                                var vertex = event.target;
                                var currentPolygon = vertex.getData().polygon;
                                var geoLineString = currentPolygon.getGeometry().getExterior();
                                var geoPoint = $scope.map.screenToGeo(pointer.viewportX, pointer.viewportY);

                                // seta nova posição pro vertexMarker
                                vertex.setGeometry(geoPoint);

                                // seta nova posição para o vertex do poligono
                                geoLineString.removePoint(vertex.getData().vertexIndex);
                                geoLineString.insertPoint(vertex.getData().vertexIndex, geoPoint);
                                currentPolygon.setGeometry(new $scope.Here.geo.Polygon(geoLineString));

                                // para a propagação do evento
                                event.stopPropagation();
                                // criar o "vertex" marker de desfazer a edição
                                returnVertex(vertex);
                            };
                            //  colcando o marker do vertex, não funciona no grupo 07/07/2026
                            $scope.vertexGroup.getObjects().forEach(function (vertex) {
                                vertex.addEventListener("pointerenter", vertexPolygonPointerenterEvent);
                                vertex.addEventListener("pointerleave", vertexPolygonPointerleaveEvent);
                            });
                            $scope.vertexGroup.addEventListener("dragstart", vertexPolygonDragstartEvent);
                            $scope.vertexGroup.addEventListener("drag", vertexPolygonDragEvent);
                        }

                        function returnVertex(vertex) {
                            if ($scope.returnMarker) {
                                $scope.map.removeObject($scope.returnMarker);
                                $scope.returnMarker = null;
                            }
                            var currentVertex = vertex;
                            var position = currentVertex.getGeometry();
                            var undoIcon = new $scope.Here.map.DomIcon(undoButtonTemplate);

                            $scope.returnMarker = new $scope.Here.map.DomMarker(
                                new $scope.Here.geo.Point(position.lat, position.lng),
                                {icon: undoIcon}
                            );
                            $scope.returnMarker.setData(
                                {
                                    vertex: currentVertex
                                }
                            );
                            $scope.map.addObject($scope.returnMarker);

                            returnMarkerTapEvent = function (event) {
                                var undoData = event.target.getData();
                                var vertex = undoData.vertex;
                                var vertexData = undoData.vertex.getData();
                                var polygon = vertexData.polygon;
                                var geoLineString = polygon.getGeometry().getExterior();
                                var currentLastVertexPosition = vertexData.lastMove;

                                var geoPoint = {
                                    lat: currentLastVertexPosition.lat,
                                    lng: currentLastVertexPosition.lng,
                                    alt: currentLastVertexPosition.alt
                                };
                                vertex.setGeometry(geoPoint);

                                geoLineString.removePoint(vertexData.vertexIndex);
                                geoLineString.insertPoint(vertexData.vertexIndex, geoPoint);
                                polygon.setGeometry(new $scope.Here.geo.Polygon(geoLineString));

                                $scope.map.removeObject($scope.returnMarker);
                                $scope.returnMarker = null;
                            };
                            $scope.returnMarker.addEventListener("tap", returnMarkerTapEvent);
                        }

                        function getConfirmBundle() {
                            if (!$scope.specifyBundleConfirm) {
                                return "maps.polygon.delete.confirm";
                            }
                            return $scope.specifyBundleConfirm;
                        }

                        function drawOthersPolygonGroups(polygonGroups) {
                            for (var i = 0; i < polygonGroups.length; i++) {
                                var polygonGroup = polygonGroups[i];
                                $scope.othersPolygonGroups.addObject(polygonGroup);
                            }
                            addDeleteListenerOfGroups();
                        }

                        function clearOthersPolygonGroups() {
                            if ($scope.othersPolygonGroups) {
                                $scope.othersPolygonGroups.removeAll();
                            }
                        }

                        function addDeleteListenerOfGroups() {
                            polygonDeleteGroupsTapEvent = function (event) {

                                if (isLeftButton(event)) {
                                    openPolygonNameBubble(event);
                                    return;
                                }

                                if (isRightButton(event)) {
                                    return;
                                }
                                if ($scope.isProcessingDeleteTap) {
                                    return;
                                }
                                event.stopPropagation();
                                $scope.isProcessingDeleteTap = true;

                                messagesModal.cancellable("dialog.warning", [getConfirmBundle()])
                                    .then(function () {
                                        var currentPolygon = event.target;
                                        var data = currentPolygon.getData();
                                        var polygonGroupToDelete = data.model.polygonGroup;
                                        $scope.othersPolygonGroups.removeObject(polygonGroupToDelete);
                                    })
                                    .finally(function () {
                                        $scope.isProcessingDeleteTap = false;
                                    });
                            };
                            $scope.othersPolygonGroups.addEventListener("tap", polygonDeleteGroupsTapEvent);
                        }

                        function openPolygonNameBubble(event) {
                            var currentPolygon = event.target;
                            var data = currentPolygon.getData();

                            if (data && data.model && data.model.name) {
                                var pointer = event.currentPointer;
                                var currentGeoPoint = $scope.map.screenToGeo(pointer.viewportX, pointer.viewportY);
                                if (!data.polygonId) {
                                    data.polygonId = Math.random().toString(36).substring(2, 10);
                                    currentPolygon.setData(data);
                                }

                                var currentPolygonId = data.polygonId;
                                if ($scope.openBubblesByPolygon[currentPolygonId]) {
                                    $scope.ui.removeBubble($scope.openBubblesByPolygon[currentPolygonId]);
                                }

                                var bubbleScope = $scope.$new(true);
                                bubbleScope.polygonData = data;
                                var newBubble = new $scope.Here.ui.InfoBubble(currentGeoPoint, {
                                    content: $compile(polygonNameModalTemplate)(bubbleScope)[0]
                                });

                                newBubble.addEventListener("statechange", function(e) {
                                    if (e.target.getState() === "closed") {
                                        delete $scope.openBubblesByPolygon[currentPolygonId];
                                        bubbleScope.$destroy();
                                    }
                                });

                                $scope.ui.addBubble(newBubble);
                                $scope.openBubblesByPolygon[currentPolygonId] = newBubble;
                            }
                        }

                        $scope.$on("$destroy", function () {
                            if ($scope.map) {

                                if ($scope.polygonGroup && $scope.polygonGroup.getObjects().length > 0) {
                                    $scope.polygonGroup.removeEventListener("tap", polygonDeleteTapEvent);
                                    $scope.polygonGroup.removeAll();
                                }
                                if ($scope.vertexGroup && $scope.vertexGroup.getObjects().length > 0) {
                                    // apaga o evento de cada um dos markers
                                    $scope.vertexGroup.getObjects().forEach(function (vertex) {
                                        vertex.removeEventListener("pointerenter", vertexPolygonPointerenterEvent);
                                        vertex.removeEventListener("pointerleave", vertexPolygonPointerleaveEvent);
                                    });
                                    $scope.vertexGroup.removeEventListener("dragstart", vertexPolygonDragstartEvent);
                                    $scope.vertexGroup.removeEventListener("drag", vertexPolygonDragEvent);
                                    $scope.vertexGroup.removeAll();
                                }
                                if ($scope.returnMarker) {
                                    $scope.returnMarker.removeEventListener("tap", returnMarkerTapEvent);
                                }
                                if ($scope.othersPolygonGroups && $scope.othersPolygonGroups.getObjects().length > 0) {
                                    $scope.othersPolygonGroups.removeEventListener("tap", polygonDeleteGroupsTapEvent);
                                    $scope.othersPolygonGroups.removeAll();
                                }
                                if ($scope.openBubblesByPolygon && $scope.ui) {
                                    for (var polygonId in $scope.openBubblesByPolygon) {
                                        $scope.ui.removeBubble($scope.openBubblesByPolygon[polygonId]);
                                    }
                                    $scope.openBubblesByPolygon = null;
                                }

                                $scope.Here = null;
                                $scope.map = null;
                                $scope.behavior = null;
                                $scope.icon = null;
                                $scope.hoverIcon = null;
                                $scope.polygonGroup = null;
                                $scope.vertexGroup = null;
                                $scope.returnMarker = null;
                                $scope.specifyBundleConfirm = null;
                            }
                        });
                    }]
            };
        }]);
});